module.exports = __webpack_public_path__ + "static/media/twitter.e7454086.svg";